// @flow

import React from 'react';
import styled from 'styled-components';

import type {AnyStepType} from 'app/steps/types';

import {gt} from 'app/utils/i18n';
import {colors} from 'js-libs/sweetcommons/styles';
import {ProcedureStepNumber} from 'app/procedures/components/ProcedureStepNumber';

type Props = {|
  step: AnyStepType,
|};

export function OrderableStep({step}: Props) {
  return (
    <StyledContainerDiv>
      <h3 className="d-flex m-0">
        <div className="icon-container pt-1 flex-shrink-0">
          <ProcedureStepNumber n={step.n} type={step.type} />
        </div>
        <div className="title-container flex-grow-1 align-self-center">
          {step.title != null && step.title !== '' ? (
            step.title
          ) : (
            <i className="unnamed">
              {step.type === 'decision'
                ? gt('Untitled decision')
                : step.type === 'processprocedure'
                ? step.deleted
                  ? gt('Deleted Procedure')
                  : gt('Untitled Procedure')
                : gt('Untitled step')}
            </i>
          )}
        </div>
        <div className="btn btn-link flex-shrink-0">
          <i className="fa fa-sort" />
        </div>
      </h3>
    </StyledContainerDiv>
  );
}

const StyledContainerDiv = styled.div.attrs({})`
  background: white;
  padding: 1rem 0;
  border-bottom: 1px dotted ${colors.mediumGray};

  .icon-container {
    width: 2.5rem;
  }
`;
